<div class="container mt-5">
  <div class="row justify-content-center">
    <div>
      <div class="card shadow-lg">
        <div class="card-header bg-primary text-white text-center">
          <h3 class="mt-2">{{ isEditMode ? 'Edit' : 'Create' }} Intent</h3>
        </div>
        <div class="card-body">
          <form #intentForm="ngForm" (ngSubmit)="onSubmit()">
            <div class="row">
              <div class="col mb-3">
                <label class="form-label">Description</label>
                <input type="text" class="form-control" placeholder="Enter a description"
                  [(ngModel)]="intent.description" name="description" required>
              </div>
            </div>

            <div class="row">
              <div class="col mb-3">
                <label class="form-label">Qualified Name</label>
                <input type="text" class="form-control" placeholder="e.g., LocalGov.Allotments.Apply"
                  [(ngModel)]="intent.qualifiedName" name="qualifiedName" required>
              </div>
            </div>

            <div class="row">
              <div class="col mb-3">
                <label class="form-label">Sample Question</label>
                <textarea class="form-control" placeholder="Enter sample question" rows="3"
                  [(ngModel)]="intent.sampleQuestion" name="sampleQuestion" required></textarea>
              </div>
            </div>

            <div class="row">
              <div class="col mb-3">
                <label class="form-label">Sample Answer</label>
                <textarea class="form-control" placeholder="Enter sample answer" rows="3"
                  [(ngModel)]="intent.sampleAnswer" name="sampleAnswer" required></textarea>
              </div>
            </div>

            <div class="row">
              <div class="col mb-3">
                <label class="form-label">Topic Phrase</label>
                <textarea class="form-control" placeholder="Enter topic phrase" rows="3"
                  [(ngModel)]="intent.topicPhrase" name="topicPhrase"></textarea>
              </div>
            </div>

            <div class="mb-3">
              <div class="form-check form-switch">
                <input class="form-check-input" role="switch" type="checkbox"
                  [(ngModel)]="intent.alwaysExportToAQA" id="alwaysExportToAQA" name="alwaysExportToAQA">
                <label for="alwaysExportToAQA" class="form-check-label">Always Export To AQA</label>
              </div>
            </div>

            <div class="row">
              <div class="col mb-3">
                <label class="form-label">Group</label>
                <select class="form-select" [(ngModel)]="intent.groupId" name="groupId" required>
                  <option value="" disabled>Select a group</option>
                  <option *ngFor="let group of groups" [value]="group.key">{{ group.value }}</option>
                </select>
              </div>
            </div>


            <div class="d-flex justify-content-center mt-4">
              <button type="submit" class="btn btn-primary me-2" [disabled]="intentForm.invalid">
                {{ isEditMode ? 'Save Changes' : 'Create Intent' }}
              </button>
              <button type="button" class="btn btn-secondary" (click)="cancel()">Cancel</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>